import { useEffect, useState } from 'react'
import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import { ChangeEvent, CustomerUserBM } from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

export type CustomerUserInput = Omit<
  CustomerUserBM,
  '_id' | 'permissions' | 'customer' | 'website'
> & {
  _id?: string
}

type Props = {
  data?: CustomerUserInput
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: (data: any, success: () => void, error: () => void) => void
  closePopup: () => void
}

const CustomerUserForm = ({ data, handleSubmit, closePopup }: Props) => {
  const { tr } = useTr()

  const initialUser: Omit<
    CustomerUserInput,
    '_id' | 'permissions' | 'customer' | 'website'
  > = {
    email: '',
    fullName: '',
  }

  const [formData, setFormData] = useState<CustomerUserInput>(initialUser)
  const [loading, setLoading] = useState(false)

  const handleChange = (e: ChangeEvent) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  useEffect(() => {
    // eslint-disable-next-line
    if (data) setFormData(data)
  }, [data])

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        setLoading(true)
        handleSubmit(
          formData,
          () => {
            setLoading(false)
            setFormData(initialUser)
          },
          () => {
            setLoading(false)
          }
        )
      }}
    >
      <h1 className='m0 primblue mbottom1'>
        {tr(TrKey.customerUsersCreateUser)}
      </h1>
      <Input
        label={tr(TrKey.name)}
        desc={tr(TrKey.customerUsersFullNameDescription)}
        required
        disabled={loading}
        type='text'
        value={formData.fullName}
        name='fullName'
        placeholder={tr(TrKey.customerUsersFillNamePlaceholder)}
        onChange={handleChange}
      />
      <Input
        label={tr(TrKey.emailAddress)}
        desc={tr(TrKey.customerUsersEmailDescription)}
        required
        disabled={loading}
        type='text'
        value={formData.email}
        name='email'
        placeholder='example@mail.com'
        onChange={handleChange}
      />
      <div className='jce gap1 flex'>
        <Button type='submit' disabled={loading}>
          {loading ? tr(TrKey.saving) : tr(TrKey.save)}
        </Button>
        <Button danger disabled={loading} onClick={closePopup}>
          {tr(TrKey.cancel)}
        </Button>
      </div>
    </form>
  )
}

export default CustomerUserForm
